import { IQuery, IQueryMediator } from 'core-ts-types';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { IChangedBusyTimeDatasource } from '../datastore/time/changed_busy_time_datasource';
import { ORMMediator } from 'utility-ts-orm';
import * as _4 from 'lodash4';

export class UnlockedTimeQuery implements IQuery {
  public model: ITimeOccurrenceDatatype[];
  private _result: {
    times: ITimeOccurrenceDatatype[];
    editing_time: string;
  };
  constructor(
    private ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
    private ngChangedBusyTimeDatasource: IChangedBusyTimeDatasource
  ) {
    ORMMediator.registerQuery(this, ngTimeOccurrenceDataSource, ngChangedBusyTimeDatasource);
  }

  run(): this {
    const changedBusyTimes = this.ngChangedBusyTimeDatasource.read();
    let times = _4
      .chain(this.ngTimeOccurrenceDataSource.store)
      .filter((time: ITimeOccurrenceDatatype) => !time.isLocked)
      .filter((time: ITimeOccurrenceDatatype) => !time.isPreview)
      .sortBy('fromInput')
      .sortBy('day.ordinal')
      .value();

    let editing_time = _4.get(
      _4.find(changedBusyTimes, (item: any) => item.is_new_time === false),
      'tracking_id',
      ''
    );

    //_isCurrentlyEditing used by ui to determine control visibility
    _4.each(times, (time: any) => {
      time.trackingId === editing_time ? (time._isCurrentlyEditing = true) : (time._isCurrentlyEditing = false);
    });
    this._result = {
      times,
      editing_time
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('ui-ng-calendar').service('ngUnlockedTimeQuery', UnlockedTimeQuery);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/query_models/unlocked_time_query.ts